<template>
  <list 
    :columns="columns" 
    :modalCreate="modalCreate" 
    :removeLink="removeLink" 
    :cardLink="cardLink" 
    :isUpdate="true"
    :isAdd="false" 
    :itemLink="itemLink" 
    :setLink="setLink" 
    :fields="fields" 
    :searchDisable="true" 
    @change="change"
    @changeFunction="changeFunction" 
    v-model="val" />
</template>
<script>
export default {
  name: "products",
  props: {
    id: {
      default: null
    }
  },
  created() {
    this.itemLink = `users/${this.id}/shops`;
    this.setLink = `users/${this.id}/shops`;
  },
  methods: {
    changeFunction(val) { },
    change(val) { },
  },
  data() {
    return {
      val: [],
      modalCreate: "status",
      fields: [
        {
          col: ' col-12 col-md-12',
          key: "name",
          label: "Название",
          type: "field",
          textType: "text",
        },
        {
          col: ' col-12 col-md-12',
          key: "new_images",
          resultKey: "media",
          label: "Фотографии торговой точки",
          type: "imgs",
          image_key: 'path_small',
          link: 'media',
        },
        {
          col: ' col-12 col-md-12',
          key: "location_id",
          label: "Адрес",
          type: "location",
        },
        {
          col: ' col-12 col-md-12',
          key: "address",
          label: "Адрес",
          type: "field",
          textType: "text",
          isMultiLang: true
        },
        {
          col: ' col-12 col-md-12',
          key: "description",
          label: "Ориентир",
          type: "textarea",
          isMultiLang: true
        },
        {
          col: ' col-12 col-md-6',
          key: "lat",
          label: "Широта",
          type: "field",
          textType: "number",
        },
        {
          col: ' col-12 col-md-6',
          key: "lon",
          label: "Долгота",
          type: "field",
          textType: "number",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_shop",
      itemLink: "orders",
      setLink: "orders",
      columns: [
        {
          key: "id",
          title: "ID",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          sortBy: 'id'
        },
        {
          key: "name",
          title: "Торговая точка",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "dealer",
          object: "llc_name",
          title: "Организация",
          checkbox: false,
          disableLink: true,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "dealer",
          object: "phone",
          disableLink: true,
          title: "Номер телефона",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "created_at",
          title: "Создан",
          dateTimeFormat: true,
        },
        {
          detail: true,
          // remove: true,
        },
      ],
    };
  },
};
</script>
